export default __webpack_public_path__ + "static/media/profile.91c12db8.png";